import {Assert, Timer} from "js-vextensions";
import React from "react";
import {Button, CheckBox, Column, Row, Spinner, Text, TextInput} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {DefaultSkin, RunInAction_Set, UseWindowEventListener} from "web-vcore";
import {store} from "../../../../Store/index.js";
import {SetLockOverlayActive} from "../JSessionUI.js";
import {FlashConfig, OverlayPanel} from "../../../../Store/main/tools/journey.js";
import * as THREE from "three";
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader.js";
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls.js";
import * as TWEEN from "@tweenjs/tween.js";
import {Group, Tween} from "@tweenjs/tween.js";
import {GetEntities, GetEntities_WithUserTag} from "../../../../Server/DB/entities.js";
import {InAndroid} from "../../../../Utils/Bridge/Bridge_Native.js";
import {GetAudioFilesWithSubpath} from "../../../../Store/main/general/CacheState.js";
import {ConceptLinkComp} from "../../../../Engine/LiveSession/Components/ConceptLinkComp.js";
import {DoorwayOverlay_current, PlaySound, SetDoorwayOverlayCurrent} from "../../../../Utils/Bridge/Bridge_Native/MediaPlayer.js";
import {liveSession} from "../../../../Engine/LiveSessionManagement.js";

export const camStartPos = new THREE.Vector3(0, 1.25, 2);
//export let camStartRot = new THREE.Euler(-.1, 0, 0);
export const camStartTarget = new THREE.Euler(0, 1.1, 0);
const adj = -0.15; // center of open doorway (for current model)

export class DoorwayOverlay extends BaseComponent<{}, {drag_downPosX: number|n, drag_lastPosX: number|n}> {
	//static current = null as DoorwayOverlay|n;

	// when window-size changes, update canvas size to match it (needed, eg. if nav-button toolbar gets hidden just after overlay closes)
	onWindowResize = ()=>{
		// update threejs renderer size
		if (this.renderer) {
			this.renderer.setSize(window.innerWidth, window.innerHeight);
		}
		// fix aspect-ratio
		const cam = this.camera;
		if (cam) {
			cam.aspect = window.innerWidth / window.innerHeight;
			cam.updateProjectionMatrix();
		}
	};

	scene: THREE.Scene;
	camera: THREE.PerspectiveCamera;
	controls: OrbitControls;
	tweenGroup: TWEEN.Group;
	renderer: THREE.WebGLRenderer;
	doorSwingable: THREE.Object3D;
	doorOpen = false;

	ComponentWillMount = ()=>{
		SetLockOverlayActive(true);
		window.addEventListener("resize", this.onWindowResize);
	}
	ComponentWillUnmount = ()=>{
		if (DoorwayOverlay_current == this) SetDoorwayOverlayCurrent(null);
		SetLockOverlayActive(false);
		this.updateTimer.Stop();
		this.CleanupThreeJS();
		window.removeEventListener("resize", this.onWindowResize);
	};

	ComponentDidMount() {
		this.InitSelections();
		this.InitThreeJS();
		this.LoadModel();
		this.updateTimer.Start();
		SetDoorwayOverlayCurrent(this);
	}

	updateTimer = new Timer(1000, ()=>{
		this.Update();
	});

	targetImageDataURL: string|n;
	InitSelections() {
		this.targetImageDataURL = GetEntities_WithUserTag("anchor").Random()?.image_embedded;
	}
	paintingMaterial: THREE.MeshStandardMaterial;
	GeneratePaintingMaterial() {
		if (this.targetImageDataURL) {
			const paintingTexture = new THREE.TextureLoader().load(this.targetImageDataURL, data=>{
				cover(data, 1);
				function cover(texture: THREE.Texture, aspect) {
					var imageAspect = texture.image.width / texture.image.height;
					if (aspect < imageAspect) {
						texture.matrix.setUvTransform(0, 0, aspect / imageAspect, 1, 0, 0.5, 0.5);
					} else {
						texture.matrix.setUvTransform(0, 0, 1, imageAspect / aspect, 0, 0.5, 0.5);
					}
				}
			});
			this.paintingMaterial = new THREE.MeshStandardMaterial({map: paintingTexture});
		} else {
			this.paintingMaterial = new THREE.MeshStandardMaterial({color: 0x808080});
		}
		if (this.paintingMesh) {
			this.paintingMesh.material = this.paintingMaterial;
		}
	}
	paintingMesh: THREE.Mesh;

	InitThreeJS() {
		this.scene = new THREE.Scene();
		this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
		this.renderer = new THREE.WebGLRenderer({antialias: true});
		this.renderer.setSize(window.innerWidth, window.innerHeight);
		// Append the renderer to the Row container
		const container = document.getElementById("threejs-container");
		if (container) {
			container.appendChild(this.renderer.domElement);
		}

		this.camera.position.set(camStartPos.x, camStartPos.y, camStartPos.z);
		//this.camera.rotation.set(camStartRot.x, camStartRot.y, camStartRot.z);

		this.controls = new OrbitControls(this.camera, this.renderer.domElement);
		this.controls.enableDamping = true;
		this.controls.dampingFactor = 0.25;
		this.controls.enableZoom = true;
		this.controls.target.set(camStartTarget.x, camStartTarget.y, camStartTarget.z);
		this.controls.enabled = false;

		this.tweenGroup = new Group();

		// Add a basic "sun" type light
		const light = new THREE.DirectionalLight(0xffffff, 1);
		light.position.set(5, 10, 7.5);
		this.scene.add(light);

		// Add a basic plane for the doorway model to sit on
		const planeGeometry = new THREE.PlaneGeometry(10, 10);
		const planeMaterial = new THREE.MeshStandardMaterial({color: 0x303030});
		const plane = new THREE.Mesh(planeGeometry, planeMaterial);
		plane.rotation.x = -Math.PI / 2;
		this.scene.add(plane);

		// add one plane to the left, and one to the right, for the brick wall
		const wallMaterial = new THREE.MeshStandardMaterial({color: 0x505050});
		const wallGeometry = new THREE.PlaneGeometry(10, 10);
		const wallLeft = new THREE.Mesh(wallGeometry, wallMaterial);
		wallLeft.position.set(-5.8 + adj, 5, 0);
		//wallLeft.rotation.y = Math.PI / 2;
		this.scene.add(wallLeft);
		const wallRight = new THREE.Mesh(wallGeometry, wallMaterial);
		wallRight.position.set(5.8 + adj, 5, 0);
		//wallRight.rotation.y = -Math.PI / 2;
		this.scene.add(wallRight);

		// add one plane behind door, as the painting behind the door
		this.GeneratePaintingMaterial();
		const paintingGeometry = new THREE.PlaneGeometry(1.5, 2.2);
		this.paintingMesh = new THREE.Mesh(paintingGeometry, this.paintingMaterial);
		this.paintingMesh.position.set(0, 1.1, -.25);
		window["painting"] = this.paintingMesh;
		//painting.rotation.y = Math.PI;
		this.scene.add(this.paintingMesh);

		if (this.lastRequestedAnimationFrame) {
			cancelAnimationFrame(this.lastRequestedAnimationFrame);
		}
		this.animate();
	}
	clock = new THREE.Clock();
	delta = 0;
	fps = 30;
	get Interval() { return 1 / this.fps; }
	lastRequestedAnimationFrame: number|0;
	animate = ()=>{
		this.delta += this.clock.getDelta();
		if (this.delta > this.Interval) {
			this.delta = this.delta % this.Interval;

			this.controls.update();
			//TWEEN.update();
			this.tweenGroup.update();
			this.renderer.render(this.scene, this.camera);
		}
		this.lastRequestedAnimationFrame = requestAnimationFrame(this.animate);
	};

	LoadModel() {
		const loader = new GLTFLoader();
		loader.load("/3D/ZUp/Doorway.glb", gltf=>{
			const model = gltf.scene;
			model.position.set(adj, 0, 0);
			this.scene.add(model);
			this.doorSwingable = gltf.scene.getObjectByName("DoorSwingable")!;
			console.log("doorSwingable:", this.doorSwingable);
			Assert(this.doorSwingable, "DoorSwingable object not found in gltf scene (Doorway.glb).");
		});
	}

	OnFirstTouchStart = (touchPosX: number, touchPosY: number)=>{
		const newDoorOpen = !this.doorOpen;
		const doorAudios = GetAudioFilesWithSubpath("Alarms/LF/Doors/");
		const doorAudiosForState = doorAudios.filter(a=>a.filePath.includes(newDoorOpen ? "_Open" : "_Close"));
		const currentAudio = doorAudiosForState.Random();

		this.ToggleDoor(currentAudio?.duration ?? undefined);

		const clComp = liveSession?.Comp(ConceptLinkComp);
		if (currentAudio == null || clComp == null) return;
		PlaySound({entry: currentAudio, allowDoorwayOverlayEffects: false}, {volume: clComp.c.soundVolume, durationLimit: clComp.c.soundDurationLimit});
	};
	OnFirstTouchMove = (touchPosX: number, touchPosY: number)=>{
	};
	OnAllTouchesEnded = ()=>{
	};

	ToggleDoor(swingDuration = 1000) {
		if (this.doorSwingable == null) return;
		const newOpen = !this.doorOpen;
		this.SetDoorOpen(newOpen, swingDuration);
	}
	SetDoorOpen(newOpen: boolean, swingDuration = 1000) {
		if (this.doorSwingable == null) return;
		if (newOpen == this.doorOpen) return;

		// if opening door, first randomize the next visible painting
		if (newOpen) {
			this.InitSelections();
			this.GeneratePaintingMaterial();
		}

		const targetRotation = newOpen ? 0 : -(Math.PI / 2);
		const tween = new TWEEN.Tween(this.doorSwingable.rotation)
			.to({y: targetRotation}, swingDuration)
			.easing(TWEEN.Easing.Quadratic.Out)
			/*.onUpdate(() => {
				// Optional: Log the rotation for debugging
				console.log(this.doorSwingable.rotation.y);
			})*/
			.start();
		this.tweenGroup.removeAll(); // clear existing tweens (only latest ever needs to be active)
		this.tweenGroup.add(tween);
		this.doorOpen = newOpen;
	}

	async StartFlashing(duration: number, c = new FlashConfig()) {
		const redLight = new THREE.PointLight(0xff0000, c.intensity, 0);
		redLight.position.set(-c.x, c.y, c.z);

		const blueLight = new THREE.PointLight(0x0000ff, c.intensity, 0);
		blueLight.position.set(c.x, c.y, c.z);

		this.scene.add(redLight);
		this.scene.add(blueLight);

		for (let time = 0; time < duration; time += c.flashInterval) {
			// for each even-indexed switch-interval period, show red light; for the second half, show blue light
			if (Math.floor(time / c.switchInterval) % 2 == 0) {
				setTimeout(()=>{
					redLight.intensity = (time / c.flashInterval) % 2 == 0 ? c.intensity : 0;
					blueLight.intensity = 0;
				}, time);
			} else {
				setTimeout(()=>{
					redLight.intensity = 0;
					blueLight.intensity = (time / c.flashInterval) % 2 == 0 ? c.intensity : 0;
				}, time);
			}
		}

		setTimeout(()=>{
			this.scene.remove(redLight);
			this.scene.remove(blueLight);
		}, duration);
	}

	CleanupThreeJS() {
		cancelAnimationFrame(this.lastRequestedAnimationFrame);
		this.renderer.dispose();
		const container = document.getElementById("threejs-container");
		if (container) container.innerHTML = "";
		//container.removeChild(this.renderer.domElement);
	}

	panelExpanded = true;
	render() {
		let {} = this.props;
		const uiState = store.main.engine.journey;
		const cam = this.camera;
		const camPos = cam?.position;
		//let camRot = cam?.rotation;
		const camTarget = this.controls?.target;

		//UseWindowEventListener("resize", [...]);

		const Change = (..._)=>this.Update();
		return (
			<div
				style={{
					position: "fixed", left: 0, top: 0, right: 0, bottom: 0, zIndex: 100,
					display: "flex", alignItems: "center", justifyContent: "center",
					background: "rgba(0, 0, 0, 0.5)", //backdropFilter: "blur(3px)",
				}}
			>
				{cam != null &&
				<Column style={{position: "fixed", top: 0, right: 0, padding: 5, background: "rgba(0,0,0,.5)"}}>
					<Row>
						{this.panelExpanded && <>
							<Button mdIcon="window-close" onClick={()=>uiState.overlay = OverlayPanel.none}/>
							<Button ml={5} mdIcon="refresh" onClick={()=>{
								// reset camera position and rotation
								camPos.set(camStartPos.x, camStartPos.y, camStartPos.z);
								//camRot.set(camStartRot.x, camStartRot.y, camStartRot.z);
								this.controls.target.set(camStartTarget.x, camStartTarget.y, camStartTarget.z);
							}}/>
							<Button ml={5} mdIcon="door-open" onClick={()=>{
								this.ToggleDoor();
							}}/>
							<Button ml={5} mdIcon="image-refresh" onClick={()=>{
								this.InitSelections();
								this.GeneratePaintingMaterial();
							}}/>
							<CheckBox ml={5} text="Lock" value={!this.controls.enabled} onChange={val=>Change(this.controls.enabled = !val)}/>
						</>}
						<Button ml={this.panelExpanded ? "auto" : 0}
							mdIcon={`arrow-collapse-${this.panelExpanded ? "right" : "left"}`}
							onClick={()=>Change(this.panelExpanded = !this.panelExpanded)}/>
					</Row>
					{this.panelExpanded && <>
						<Row>
							<Text style={{width: 60}}>Cam pos:</Text>
							<TextInput value={`${camPos.x.toFixed(2)},${camPos.y.toFixed(2)},${camPos.z.toFixed(2)}`} onChange={val=>{
								const p = val.split(",");
								camPos.set(parseFloat(p[0]), parseFloat(p[1]), parseFloat(p[2]));
								//this.controls.update();
							}}/>
						</Row>
						{/*<Row>
							<Text style={{width: 60}}>Cam rot:</Text>
							<TextInput value={`${camRot.x.toFixed(2)},${camRot.y.toFixed(2)},${camRot.z.toFixed(2)}`} onChange={val=>{
								const p = val.split(",");
								//camRot.set(parseFloat(p[0]), parseFloat(p[1]), parseFloat(p[2]));
								this.controls.target.set(parseFloat(p[0]), parseFloat(p[1]), parseFloat(p[2]));
								this.controls.update();
							}}/>
						</Row>*/}
						<Row>
							<Text style={{width: 60}}>Target:</Text>
							<TextInput value={`${camTarget.x.toFixed(2)},${camTarget.y.toFixed(2)},${camTarget.z.toFixed(2)}`} onChange={val=>{
								const p = val.split(",");
								this.controls.target.set(parseFloat(p[0]), parseFloat(p[1]), parseFloat(p[2]));
								this.controls.update();
							}}/>
						</Row>
						<Row>
							<Text style={{width: 60}}>FPS:</Text>
							<Spinner value={this.fps} onChange={val=>Change(this.fps = val)}/>
						</Row>
					</>}
				</Column>}
				<Row id="threejs-container"
					style={{
						width: "100%", height: "100%",
						touchAction: "none",
					}}
					// use "touches" rather than "changedTouches"; this way, if multiple fingers are down, we only process the first one (else can accidentally unlock by just having a contact-point on each side)
					onTouchStart={e=>e.touches.length == 1 && this.OnFirstTouchStart(e.touches[0].clientX, e.touches[0].clientY)}
					onMouseDown={e=>!InAndroid(0) && this.OnFirstTouchStart(e.clientX, e.clientY)}
					onTouchMove={e=>this.OnFirstTouchMove(e.touches[0].clientX, e.touches[0].clientY)}
					onMouseMove={e=>this.OnFirstTouchMove(e.clientX, e.clientY)}
					//onTouchEnd={e=>this.OnTouchEnd(e.touches[0].clientX, e.touches[0].clientY)}
					//onMouseUp={e=>this.OnTouchEnd(e.clientX, e.clientY)}
					onTouchEnd={e=>e.touches.length == 0 && this.OnAllTouchesEnded()}
					onMouseUp={e=>!InAndroid(0) && this.OnAllTouchesEnded()}
				>
					{/* 3D scene will be rendered by Three.js */}
				</Row>
			</div>
		);
	}
}